import React from "react";
import Event from "./Event.js";
import ModalForm from "./Form/Form.js";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import ApiRequest from "./ApiRequest";
import Progress from "./../myAccount/Connections/Components/Progress";

export default class ConnectUserModal extends ModalForm {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
      errors: {},
      errorMessage: null,
      successMessage: null,
      loading: false,
      user: null,
      done: false
    };
  }

  componentDidMount() {
    if (this.props.show) {
      this.setState({ show: true });
      this.sendAnalyticsPageView('connectuser');
    }

    Event.on(
      "connectUserModal.show",
      user => {
        if (window.loggedInUser) {
          this.setState({
            done: false,
            show: true,
            user,
            errors: {},
            successMessage: null,
            errorMessage: null
          });
        } else {
          window.location.href = "/login";
        }
      },
      this._rootNodeID
    );

    Event.on(
      "modals.close",
      () => {
        this.setState({ show: false });
      },
      this._rootNodeID
    );
  }

  componentWillUnmount() {
    Event.off("connectUserModal.show", this._rootNodeID);
    Event.off("modals.close", this._rootNodeID);
  }

  closeModal(forcedUnmount = false) {
    this.setState({ show: false }, ()=> {
      if (forcedUnmount) this.props.onHideButton();
     });
  }

  sendRequest(access_uid) {

    this.setState(
      { loading: true, successMessage: null, errorMessage: null, errors: {} },
      () => {
        let request = new ApiRequest();

        request.post(
          `my-account/connections/request-connect/${access_uid}`,
          {},
          (err, res) => {
            if (res && res.body && res.body.success) {
              window.userConnections.push(access_uid);
              this.setState(
                { done: true,loading: false,successMessage: "Your request to connect was sent"},
                () => {
                  setTimeout(() => { this.closeModal(); }, 1500);
                }
              );
            } else {
              if (res && res.body && res.body.hasOwnProperty("messages")) {
                this.setState({loading: false, errorMessage: res.body.messages[0]});
              } else {
                if (res && res.body && !res.body.success && res.body.messages[0]) {
                  this.setState({loading: false, errorMessage: res.body.message[0]});
                }
                this.setState({
                  errorMessage: "Something went wrong. Please try again.",
                  loading: false
                });
              }
            }
          }
        );
      }
    );
  }

  render() {
    return (
      <Modal isOpen={this.state.show} toggle={() => this.toggle()}>
        <ModalHeader toggle={() => this.toggle()}>Connection Request</ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-12">
              {this.showSuccessMessage()}
              {this.showErrorMessage()}
              {this.state.done
                ? null
                : <span>
                    Would you like to send a request to connect to
                    :{" "}
                    {this.state.user
                      ? `${this.state.user.firstname} ${this.state.user.lastname}`
                      : ""}
                    ?
                  </span>
              }
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <div className="row">
            <div className="col-6 text-left">
              <button
                disabled={this.state.done}
                className="btn btn-warning"
                onClick={() => this.closeModal()}
              >
                No
              </button>
            </div>
            <div className="col-6 text-right">
              <button
                disabled={this.state.done}
                className="btn btn-primary"
                onClick={() => this.sendRequest(this.state.user.access_uid)}
              >
                Yes
              </button>
            </div>
          </div>
        </ModalFooter>
        <Progress visible={this.state.loading} />
      </Modal>
    );
  }
}
